export function testJqueryFunc1($) {
  var startString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'TEXT:';
  var text = $('body').find('header').text();
  console.log(startString + text);
}
export function testJqueryFunc2($) {
  var text = $('body').find('footer').text();
  console.log(text);
}